import { ClientDocumentsUploadExperience } from "./ClientDocumentsUploadPage";

export default function ClientDocumentsUploadMobilePage() {
  return <ClientDocumentsUploadExperience isMobile />;
}
